<form #form="ngForm" (ngSubmit)="submit()">
  <nx-ng-modal-header
    [title]="'basket_modal_title' | i18next"
  ></nx-ng-modal-header>

  <ng-container
    *ngIf="{
      basket: checkoutFacade.selectBasketWithDescriptions$ | async
    } as basketWrapper"
  >
    <mat-dialog-content>
      <ng-container *ngIf="basketWrapper.basket">
        <ng-container
          *ngFor="
            let item of basketWrapper.basket.basketItems;
            trackBy: trackByFn
          "
        >
          <nx-ng-basket-item
            [id]="'basket-item' + item.ticketID"
            [title]="item.title"
            [description]="item.subtitle"
            [price]="item.subTotalPrice"
            [count]="item.quantity"
            [banner]="item.isDirectDebit ? 'direct_debit' : ''"
            [termDateFrom]="item.termDateFrom"
            [termDateTo]="item.termDateTo"
            (quantityUpdated)="handleQuantityUpdated(item, $event)"
            (infoClicked)="handleShowInfoClicked(item)"
          >
          </nx-ng-basket-item>
        </ng-container>
      </ng-container>

      <nx-ng-empty-basket
        *ngIf="!basketWrapper.basket || basketWrapper.basket.totalItems === 0"
        [label]="'basket_empty'"
      ></nx-ng-empty-basket>

      <div mat-dialog-actions class="bottom">
        <nx-ng-basket-discount-voucher
          *ngIf="basketWrapper.basket && basketWrapper.basket.totalItems > 0"
          [loading]="discount.loading"
          [error]="discount.error"
          [voucherCode]="discount.voucherCode"
          [applied]="discount.applied"
          [expanded]="discount.expanded"
          (applyDiscount)="handleDiscountApplied(basketWrapper.basket.basketId, $event)"
          (removeDiscount)="handleDiscountRemoved(basketWrapper.basket.basketId, discount.voucherCode)"
        >
        </nx-ng-basket-discount-voucher>

        <nx-ng-summary-totals
          [basket]="basketWrapper.basket"
          [subtotalBasketPrice]="checkoutFacade.subtotalBasketPrice$ | async"
          [totalBasketPrice]="checkoutFacade.totalBasketPrice$ | async"
        ></nx-ng-summary-totals>

        <div class="basket_action_buttons">
          <nx-ng-submit-button
            *ngIf="checkoutFacade.validBasket$ | async"
            cdkFocusInitial
            class="continue basket_action_buttons__button"
            [attr.aria-label]="'basket_aria_continue' | i18next"
            [labelKey]="'button_continue'"
          >
          </nx-ng-submit-button>

          <nx-ng-basket-add-item
            *ngIf="basketWrapper.basket && basketWrapper.basket.totalItems > 0"
            [label]="'basket_add_another_ticket'"
            (addBasketItem)="routeToTicketTypes($event)"
            class="basketAddItem basket_action_buttons__button"
          ></nx-ng-basket-add-item>

          <nx-ng-submit-button
            *ngIf="!basketWrapper.basket || basketWrapper.basket.totalItems === 0"
            cdkFocusInitial
            class="continue basket_action_buttons__button"
            [attr.aria-label]="'basket_add_ticket' | i18next"
            [labelKey]="'basket_add_ticket'"
            [type]="'button'"
            (submitted)="routeToTicketTypes()"
          >
          </nx-ng-submit-button>
        </div>
      </div>
    </mat-dialog-content>
  </ng-container>
</form>
